
























import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Event from '@/models/Event'
import TinyMce from '@/components/admin/TinyMce.vue'

@Component({
  components: {
    TinyMce
  }
})
export default class EventForm extends VueBase {
  @Prop(Object) readonly value!: Event

  @Emit('input')
  input(value: Event): Event {
    return value
  }

  @Emit()
  onSave(): Event {
    return this.value
  }

  get internalValue(): Event {
    return this.value
  }

  set internalValue(val: Event) {
    this.input(val)
  }
}
